// extracted by mini-css-extract-plugin
module.exports = {"content":"sliding-footer_content__KFSEB","footer":"sliding-footer_footer__arRKz"};